import React from 'react'
import _ from 'lodash'
import { getRegistrationBanners } from '../api/requests/Register'
import LoginBanner from '../../assets/img/simplified-login/login.webp'
import MobileBanner from '../../assets/img/simplified-login/register.webp'
import ProfileBanner from '../../assets/img/simplified-login/customer-details.webp'
import OtpBanner from '../../assets/img/simplified-login/otp.webp'
import SuccesBanner from '../../assets/img/simplified-login/success.webp'

export const REGISTRATION_STEPS = {
  LOGIN: 'LOGIN',
  LOGIN_OTP: 'LOGIN_OTP',
  REGISTER_MOBILE: 'MOBILE',
  REGISTER_CUSTOMER_DETAILS: 'PROFILE',
  REGISTER_OTP: 'OTP',
  REGISTER_SUCCESS: 'SUCCESS',
}
const DEFAULT_REGISTER_BANNERS = {
  LOGIN: LoginBanner,
  LOGIN_OTP: OtpBanner,
  MOBILE: MobileBanner,
  PROFILE: ProfileBanner,
  OTP: OtpBanner,
  SUCCESS: SuccesBanner,
}
let banners = Object.assign({}, DEFAULT_REGISTER_BANNERS)
const useRegistrationBanners = ({ registrationStep }) => {
  const [loading, setLoading] = React.useState(true)
  // eslint-disable-next-line no-unused-vars
  const [bannerList, setBannerList] = React.useState(banners)

  const fetchBanners = async () => {
    try {
      setLoading(true)
      const { data } = await getRegistrationBanners()
      const formattedData = formatData(data)
      banners = formattedData
      setBannerList(formattedData)
      setLoading(false)
      return formattedData
    } catch (error) {
      setBannerList(banners)
      setLoading(false)
    }
  }

  const getBanners = async () => {
    if (!_.isEqual(banners, DEFAULT_REGISTER_BANNERS)) {
      setLoading(false)
      return banners
    }

    const responseData = await fetchBanners()
    return responseData
  }

  const formatData = data => {
    const defaultCopy = Object.assign({}, DEFAULT_REGISTER_BANNERS)
    data.forEach(b => {
      if (!!b.imageUrl) defaultCopy[b.step] = b.imageUrl
    })

    return defaultCopy
  }

  const getRegistrationStepBanner = (checkStep = registrationStep) => {
    return banners[checkStep]
  }

  return {
    loading,
    banners,
    getBanners,
    getRegistrationStepBanner,
    refreshBanners: fetchBanners,
  }
}

export default useRegistrationBanners
